import { render } from "./AddManualProject.vue?vue&type=template&id=749401c6"
import script from "./AddManualProject.vue?vue&type=script&lang=js"
export * from "./AddManualProject.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__